import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators,} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Project} from 'src/app/models/project.model';
import {ProjectService} from 'src/app/services/project.service';
import {map, Observable, Subscription} from 'rxjs';
import {UploadService} from 'src/app/services/upload.service';
import {ProjectCategory} from 'src/app/models/project-category.model';
import {ProjectCategoryService} from 'src/app/services/project-category.service';


@Component({
  selector: 'app-project-edit',
  templateUrl: './project-edit.component.html',
  styleUrls: ['./project-edit.component.css'],
})
export class ProjectEditComponent implements OnInit {
  showSpinner: boolean = false;

  project: Project;
  // logoFile: File[] = [];
  logoFile: File[] = [];
  imageProject: File[] = [];
  sponsorImages: File[] = [];
  partnerImages: File[] = [];
  categories: ProjectCategory[] = [];
  categorySubscription$: Subscription;
  array: any = [];
  arrayTest: any = [];

  projectForm: FormGroup;
  projectPreview$: Observable<Project>;

  // PREVIEW IMAGES
  previewLogoProject = '';
  previewProjectImage = '';
  previewSponsorImage: any[] = [];
  previewPartnerImage: any[] = [];

  projectCategory: ProjectCategory;

  constructor(
    private fb: FormBuilder,
    private projectService: ProjectService,
    private router: Router,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private projectCategoryService: ProjectCategoryService
  ) {
  }

  get contentControl() {
    return this.projectForm.controls['content'] as FormControl;
  }

  ngOnInit(): void {
    this.projectCategoryService.getAllCategorys();
    window.scrollTo(0, 0);
    this.categorySubscription$ =
      this.projectCategoryService.projectCategorySubject$.subscribe(
        (response: any) => {
          this.categories = response;
          this.array = response;
        },
        (error) => {
          console.log('An error occured: ' + error);
        }
      );
    const id = +this.route.snapshot.params['id'];
    this.projectService.getProject(id).subscribe((response: Project) => {
      this.project = response;
      this.project.sponsor_images_url =
        this.projectService.convertStringToArray(response.sponsor_images_url);
      this.project.partners_images_url =
        this.projectService.convertStringToArray(response.partners_images_url);
      console.log('This is the project', this.project);
      this.initForm(this.project);

      this.projectPreview$ = this.projectForm.valueChanges.pipe(
        map((formValue) => ({
          ...formValue,
        }))
      );
    });
  }

  initForm(project: Project) {
    this.projectForm = this.fb.group({
      title: [project.title, Validators.required],
      content: [project.content, Validators.required],
      /* category_id: [project.category_id, Validators.required], */
      project_icon_url: [project.project_icon_url],
      project_image_url: [project.project_image_url],
      sponsor_images_url: [project.sponsor_images_url],
      partners_images_url: [project.partners_images_url],
      director: [project.lead],
      code: [project.code],
      start_date: [project.start_date],
      end_date: [project.end_date],
      location: [project.location],
    });
  }

  removeImage(url: string, type: string) {
    switch (type) {
      case 'icon':
        this.projectForm.get('project_icon_url')?.patchValue('');
        break;
      case 'cover':
        this.projectForm.get('project_image_url')?.patchValue('');
        break;
      case 'sponsor':
        const sponsorImagesUrl = this.projectForm.get('sponsor_images_url')
          ?.value as string[];
        const filteredSponsorImagesUrl = sponsorImagesUrl.filter(
          (imageUrl) => imageUrl !== url
        );
        this.projectForm
          .get('sponsor_images_url')
          ?.patchValue(filteredSponsorImagesUrl);
        break;
      case 'partner':
        const partnerImagesUrl = this.projectForm.get('partners_images_url')
          ?.value as string[];
        const filteredPartnerImagesUrl = partnerImagesUrl.filter(
          (imageUrl) => imageUrl !== url
        );
        this.projectForm
          .get('partners_images_url')
          ?.patchValue(filteredPartnerImagesUrl);
        break;
      default:
        console.log('Invalid image type');
    }
  }

  async submitForm() {
    this.showSpinner = true;
    console.log(
      'Available to upload....comes>>>>>>>>',
      this.logoFile,
      this.imageProject,
      this.sponsorImages,
      this.partnerImages
    );

    if (this.logoFile.length !== 0) {
      const logoPayload = this.cloudinaryRequestFormatter(this.logoFile[0]);
      let logoResponse: any = await this.sentToCloudinary(logoPayload)
      console.log('Logo response', logoResponse);

      this.projectForm.get('project_icon_url')?.patchValue(logoResponse.secure_url);
      this.projectForm.get('project_icon_url')?.updateValueAndValidity();
    }

    if (this.imageProject.length !== 0) {
      const bannerPayload = this.cloudinaryRequestFormatter(this.imageProject[0]);
      let bannerResponse: any = await this.sentToCloudinary(bannerPayload);
      console.log('Banner Response', bannerResponse);

      this.projectForm.get('project_image_url')?.patchValue(bannerResponse.secure_url);
      this.projectForm.get('project_image_url')?.updateValueAndValidity();
    }

    if (this.sponsorImages.length !== 0) {
      const imageUrls: any = [];

      for (let file of this.sponsorImages) {
        let sponsorImagePayload = this.cloudinaryRequestFormatter(file);
        let sponsorImagesResponse: any = await this.sentToCloudinary(sponsorImagePayload);
        console.log('Sponsor Response', sponsorImagesResponse);

        imageUrls.push(sponsorImagesResponse.secure_url);
      }

      // Combine existing sponsor images with new ones, ensuring we don't exceed 3
      const existingSponsorImages = this.projectForm.get('sponsor_images_url')?.value || [];
      const allSponsorImages = [...existingSponsorImages, ...imageUrls];
      const limitedSponsorImages = allSponsorImages.slice(0, 3); // Limit to 3 images

      this.projectForm.get('sponsor_images_url')?.patchValue(limitedSponsorImages);
      this.projectForm.get('sponsor_images_url')?.updateValueAndValidity();
    }

    if (this.partnerImages.length !== 0) {
      const imageUrls: any = [];

      for (let file of this.partnerImages) {
        let partnerImagePayload = this.cloudinaryRequestFormatter(file);
        let partnerImageResponse: any = await this.sentToCloudinary(partnerImagePayload);
        console.log('Partner Response', partnerImageResponse);

        imageUrls.push(partnerImageResponse.secure_url);
      }

      // Combine existing partner images with new ones, ensuring we don't exceed 6
      const existingPartnerImages = this.projectForm.get('partners_images_url')?.value || [];
      const allPartnerImages = [...existingPartnerImages, ...imageUrls];
      const limitedPartnerImages = allPartnerImages.slice(0, 6); // Limit to 6 images

      this.projectForm.get('partners_images_url')?.patchValue(limitedPartnerImages);
      this.projectForm.get('partners_images_url')?.updateValueAndValidity();
    }

    this.submitHandler();
    this.showSpinner = false;
  }

  cloudinaryRequestFormatter(payload: any) {
    const cloudinaryFormData = new FormData();
    cloudinaryFormData.append('file', payload);
    cloudinaryFormData.append('upload_preset', 'vmdo-project');
    cloudinaryFormData.append('cloud_name', 'kaeyros-cloudinary');

    console.log('FORM DATA cloudinary', cloudinaryFormData);

    return cloudinaryFormData;
  }

  submitHandler() {
    const formValue = this.projectForm.value;
    console.log('formValue', formValue['partners_images_url']);
    const project: Project = {
      title: formValue['title'],
      content: formValue['content'],
      /* category_id: formValue['category_id'], */
      start_date: formValue['start_date'],
      end_date: formValue['end_date'],
      location: formValue['location'],

      project_icon_url: formValue['project_icon_url'],
      project_image_url: formValue['project_image_url'],
      sponsor_images_url: formValue['sponsor_images_url'],
      partners_images_url: formValue['partners_images_url'],
      lead: formValue['director'],
      code: formValue['code'],
      partners_images_urls: formValue['partners_images_urls'],
    };
    console.log('PPROJECCT', project);

    if (formValue['project_icon_url']) {
      project.project_icon_url = formValue['project_icon_url'];
    } else {
      project.project_icon_url = ' ';
    }

    if (formValue['project_image_url']) {
      project.project_image_url = formValue['project_image_url'];
    } else {
      project.project_image_url = ' ';
    }

    if (formValue['sponsor_images_url'] && formValue['sponsor_images_url'].length > 0) {
      project.sponsor_images_url = formValue['sponsor_images_url'];
    } else {
      project.sponsor_images_url = [''];
    }

    if (formValue['partners_images_url'] && formValue['partners_images_url'].length > 0) {
      project.partners_images_url = formValue['partners_images_url'];
    } else {
      project.partners_images_url = [''];
    }

    this.projectService
      .editProject(this.project.id ?? 0, project)
      .subscribe(
        (response) => {
          this.projectService.getAllProjects();
          this.projectService.emitProjectSubject();
          formValue['project_icon_url'];
          console.log(response);
          this.router.navigate([`/projects/${response.id}`]);
        },
        (error) => {
          console.error(`An error occured: ${error.message}`);
        }
      );

  }

  cancelEdit() {
    this.router.navigateByUrl('/projects/list');
  }

  // UPLOAD LOGO PROJECT
  onSelectLogo(event: any) {
    // Only allow one file, take the first one if multiple are selected
    if (event.addedFiles && event.addedFiles.length > 0) {
      this.logoFile = [event.addedFiles[0]]; // Only keep the first file

      const file = this.logoFile[0];
      if (file) {
        this.previewLogoProject = '';
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.previewLogoProject = e.target.result;
        };

        reader.readAsDataURL(file);
      }
    }
  }

  onRemoveLogo(event: any) {
    this.logoFile = []; // Clear the array instead of splicing
    this.previewLogoProject = '';
  }


  // UPLOAD IMAGE PROJECT
  onSelectImageProject(event: any) {
    // Only allow one file, take the first one if multiple are selected
    if (event.addedFiles && event.addedFiles.length > 0) {
      this.imageProject = [event.addedFiles[0]]; // Only keep the first file

      const file = this.imageProject[0];
      if (file) {
        this.previewProjectImage = '';
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.previewProjectImage = e.target.result;
        };

        reader.readAsDataURL(file);
      }
    }
  }

  onRemoveImageProject(event: any) {
    this.imageProject = []; // Clear the array instead of splicing
    this.previewProjectImage = '';
  }


  // UPLOAD SPONSOR IMAGE PROJECT
  onSelectSponsorImage(event: any) {
    // Vérifiez d'abord si le nombre total d'images ne dépasse pas 3
    if (this.sponsorImages.length < 3) {
      // Calcul du nombre d'images restantes pouvant être ajoutées
      const remainingSlots = 3 - this.sponsorImages.length;

      // Si le nombre d'images restantes est supérieur à 0, nous pouvons ajouter de nouvelles images
      if (remainingSlots > 0) {
        // Ajout des nouvelles images jusqu'à ce que le nombre maximum soit atteint
        const addedFiles = event.addedFiles.slice(0, remainingSlots);
        this.sponsorImages.push(...addedFiles);

        // Affichage des prévisualisations d'images
        const files = addedFiles;

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = () => {
            this.previewSponsorImage.push(reader.result as string);
          };
          reader.readAsDataURL(file);
        }
      } else {
        // block images adding or display an error message
        console.log("Le nombre maximum d'images est atteint");
      }
    } else {
      // block images adding or display an error message
      console.log("Le nombre maximum d'images est atteint");
    }
  }


  onSelectParntnerImage(event: any) {
    // Vérifiez d'abord si le nombre total d'images ne dépasse pas 6
    if (this.partnerImages.length < 6) {
      // Calcul du nombre d'images restantes pouvant être ajoutées
      const remainingSlots = 6 - this.partnerImages.length;

      // Si le nombre d'images restantes est supérieur à 0, nous pouvons ajouter de nouvelles images
      if (remainingSlots > 0) {
        // Ajout des nouvelles images jusqu'à ce que le nombre maximum soit atteint
        const addedFiles = event.addedFiles.slice(0, remainingSlots);
        this.partnerImages.push(...addedFiles);

        // Affichage des prévisualisations d'images
        const files = addedFiles;

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const reader = new FileReader();
          reader.onload = () => {
            this.previewPartnerImage.push(reader.result as string);
          };
          reader.readAsDataURL(file);
        }
      } else {
        // block images adding or display an error message
        console.log("Le nombre maximum d'images est atteint");
      }
    } else {
      // block images adding or display an error message
      console.log("Le nombre maximum d'images est atteint");
    }
  }


  onRemoveSponsorImage(event: any) {
    this.sponsorImages.splice(this.sponsorImages.indexOf(event), 1);
    this.previewSponsorImage.splice(this.previewSponsorImage.indexOf(event), 1);

  }

  // This is to remove partner image files
  onRemovePartnerImage(event: any) {
    this.partnerImages.splice(this.partnerImages.indexOf(event), 1);
    this.previewPartnerImage.splice(this.previewPartnerImage.indexOf(event), 1);
  }

  sentToCloudinary(data: any) {
    return new Promise((resolve, reject) => {
      this.uploadService.uploadImage(data).subscribe(
        (response) => {
          console.log('Cloudinary Response', response);
          resolve(response);
        },
        (error) => {
          reject();
        }
      );
    });
  }

  // carry this code into a helper service later
  convertStringToArray(inputString: any) {
    const trimmedString = inputString.trim();

    // Check if the string starts and ends with square brackets
    if (trimmedString.startsWith('[') && trimmedString.endsWith(']')) {
      // Remove the square brackets
      const stringWithoutBrackets = trimmedString.slice(1, -1);

      // Split the remaining string by commas
      const stringArray = stringWithoutBrackets.split(',');

      // Trim and wrap each element in single quotes
      const resultArray = stringArray.map(
        (element: any) => `${element.trim().slice(1, -1)}`
      );

      return resultArray;
    } else {
      console.error('Input is not in the expected format.');
      return [];
    }
  }

}
